(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/game-container.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/game-container.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect;
const _svs$kenoXpress$react = svs.kenoXpress.react.utils.wager,
  isWagerCompleted = _svs$kenoXpress$react.isWagerCompleted,
  getWager = _svs$kenoXpress$react.getWager;
const GameContainer = () => {
  const Payfooter = svs.tur.ReactPayfooter.Payfooter;
  const _svs$kenoXpress$react2 = svs.kenoXpress.react.components,
    Betslip = _svs$kenoXpress$react2.Betslip,
    Receipt = _svs$kenoXpress$react2.Receipt,
    GameUnavailable = _svs$kenoXpress$react2.GameUnavailable;
  const _svs$kenoXpress$react3 = svs.kenoXpress.react.hooks.useKenoXpress(),
    ref = _svs$kenoXpress$react3.ref,
    loading = _svs$kenoXpress$react3.loading,
    gameState = _svs$kenoXpress$react3.gameState,
    showPayment = _svs$kenoXpress$react3.showPayment,
    isAlreadyPayed = _svs$kenoXpress$react3.isAlreadyPayed,
    gameUnavailable = _svs$kenoXpress$react3.gameUnavailable,
    handleDemoGame = _svs$kenoXpress$react3.handleDemoGame,
    handlePayGame = _svs$kenoXpress$react3.handlePayGame,
    onPlayAgain = _svs$kenoXpress$react3.onPlayAgain;
  const _svs$kenoXpress$react4 = svs.kenoXpress.react.hooks.useFullSizeScreenGameResize(ref),
    _svs$kenoXpress$react5 = _slicedToArray(_svs$kenoXpress$react4, 1),
    resizeGame = _svs$kenoXpress$react5[0];
  const isCompleted = isWagerCompleted();
  svs.kenoXpress.react.hooks.useLoader(ref, loading);
  useEffect(() => {
    resizeGame();
  }, [resizeGame, showPayment, loading]);
  if (gameUnavailable) {
    return React.createElement(GameUnavailable, null);
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "keno-xpress-leia-flex"
  }, React.createElement("div", {
    className: "keno-xpress-leia"
  }, React.createElement("div", {
    ref: ref
  }))), React.createElement("div", {
    id: "kex-pay-footer"
  }, !loading && isCompleted ? React.createElement(Receipt, {
    wager: getWager()
  }) : null, showPayment && React.createElement(Betslip, {
    handleDemoGame: handleDemoGame,
    handlePayGame: handlePayGame,
    hasKungKeno: gameState.kungKeno,
    isAlreadyPayed: isAlreadyPayed,
    isVisible: Boolean(gameState.kenoNumbers.length),
    selectedPrice: gameState.stake
  }), !loading && isCompleted && React.createElement(Payfooter, {
    buttons: [{
      primary: true,
      text: 'Spela igen',
      onClick: onPlayAgain
    }],
    isFixed: true,
    reminderTrackingLabel: "KenoXpress"
  })));
};
svs.kenoXpress.react.GameContainer = GameContainer;

 })(window);